
import ProjectCard from "../PageLayout/ProjectCard";
import ProjectHeader from "../Projects/ProjectHeader";
import { ProjectType } from "../Utils/ProjectType.ts";
import sharedStyles from "./music-shared.module.css";


export default function Corcovado () {


    return (
        <ProjectCard projectName={"Corcovado"} >
            <ProjectHeader title="CORCOVADO" subTitle={"Jan / Karolyna"} projectType={ProjectType.Music} />

            <p> I’m a huge fan of jazz guitar, especially bossa nova. João Gilberto’s style massively inspires me. His version of Corcovado with Stan Getz and Astrud Gilberto from the Getz/Gilberto album (1964) is a particular favourite of mine. There’s something so delicate and atmospheric about it. It makes me feel like I’m sitting on the balcony of an apartment in a far away city, the sun setting slowly, the street gently bustling below, and I’m reflecting on life. </p>
            <p> Also, it was great fun getting to meet and work with Karolyna! Her voice suited the track so perfectly. I think this might be my favourite musical project I’ve worked on so far. </p>

            <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/aaT5WE6b6zo" title="Corcovado (Quiet Nights of Quiet Stars) | Getz/Gilberto Inspired Bossa Nova Cover - Jan &amp; Karolyna" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>

        </ProjectCard>
    )
}